import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ProfilePage from './pages/ProfilePage';
import QuestionnairePage from './pages/QuestionnairePage';
import ResultPage from './pages/ResultPage';
import RankingPage from './pages/RankingPage';
import WelcomePage from './pages/WelcomePage';
import CheckProfile from './pages/CheckProfile';
import ThankYouPage from './pages/ThankYouPage';
import FAQPage from './pages/FAQPage';
import Uputstva from './pages/Uputstva';
import FullRankingPage from './pages/FullRankingPage';
import Sidebar from './pages/Sidebar';
import { useIsMobile } from './hooks/useIsMobile';

function App() {
  return (
    <Router>
      <Layout />
    </Router>
  );
}

function Layout() {
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const isMobile = useIsMobile(); // naš custom hook

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const closeSidebar = () => setSidebarOpen(false);

  // Sakrij sidebar i header na login i register
  const hideSidebar = location.pathname === '/' || location.pathname === '/register';

  return (
    <div className="app-container">
{!hideSidebar && isMobile && (
  <header className="header">
    <button className="hamburger" onClick={toggleSidebar}>☰</button>
  </header>
)}

     

      {/* Sidebar prikazujemo samo kad nije login/register */}
      {!hideSidebar && <Sidebar isOpen={sidebarOpen} closeSidebar={closeSidebar} />}

      <div className="main-content" onClick={closeSidebar}>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/welcome" element={<WelcomePage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/check-profile" element={<CheckProfile />} />
          <Route path="/questionnaire/:categoryId" element={<QuestionnairePage />} />
          <Route path="/result/:categoryId" element={<ResultPage />} />
          <Route path="/ranking" element={<RankingPage />} />
          <Route path="/uputstva" element={<Uputstva />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
          <Route path="/full-ranking" element={<FullRankingPage />} />
        </Routes>
      </div>

    </div>
  );
}

export default App;
